module.exports = __webpack_public_path__ + "static/media/MacPro_createEmail_small.5414392a.png";